import React from "react";
import Chart from "../../common/ApexChart";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import allApi from "../../../../api/allApi";
import { useLocalization } from "../../localization/LocalizationContext";
import { useNetwork } from "../../common/networkContext";

function TrafficBandwithExpandation() {
  const { localizationStrings } = useLocalization();
  const { selectedNetworkId, selectedLocation } = useNetwork();
  const networkId = selectedNetworkId?.id ?? 6001;
  const [trafficSeries, setTrafficSeries] = useState([]);
  const [trafficCategories, setTrafficCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trafficDuration, setTrafficDuration] = useState("24h");
  const [timeFormat, setTimeFormat] = useState(); // Default format

  useEffect(() => {
    getTrafficBandwidthData(trafficDuration,networkId);
  }, [trafficDuration,networkId]);

  const getTrafficBandwidthData = async (trafficDuration,networkId) => {
    try {
      setLoading(true);
      const api = new allApi();
      const response = await api.getRequest(
        `api/wireless/totalBandWidth?commandType=5&duration=${trafficDuration}&networkId=${networkId}`
      );

      if (response.status === "OK") {
        const data = response.response; // Adjusted to your provided response structure

        // Prepare the series data for each serial number
        const seriesData = data.map((item) => ({
          name: item.serialNumber, // Serial number as the legend
          data: item.data.map((trafficItem) => ({
            x: new Date(trafficItem.interval1).getTime(), // Convert date string to milliseconds
            y: trafficItem.totalUtilization, // Total utilization for the point
          })),
        }));

        // Gather unique timestamps (x-axis values)
        const timestamps = seriesData.flatMap((series) =>
          series.data.map((point) => point.x)
        );
        const uniqueTimestamps = Array.from(new Set(timestamps)).sort(
          (a, b) => a - b
        );

        // Set the traffic categories (x-axis) and series for rendering
        setTrafficCategories(uniqueTimestamps);
        setTrafficSeries(seriesData);
      } else {
        console.error("Failed to fetch traffic data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching traffic data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTrafficDurationChange = (trafficDuration) => {
    setTrafficDuration(trafficDuration);
  };

  const TrafficOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: "datetime",
      tickAmount: 6,

      labels: {
        formatter: (value) => {
          const date = new Date(value);

          // Check the duration and format accordingly
          if (trafficDuration == "7d" || trafficDuration == "30d") {
            const options = {
              day: "2-digit",
              month: "short",
              timeZone: "Asia/Kolkata",
            };
            console.log("option1", options);
            return date.toLocaleString("en-IN", options); // Format: "dd MMM"
          } else {
            const options = {
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "Asia/Kolkata",
              hour12: false,
            };
            console.log("option2", options);
            return date.toLocaleString("en-IN", options); // Format: "HH:mm"
          }
        },
        style: {
          colors: "#9aa0ac",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: true,
        color: "#d6d6d6",
      },
      axisTicks: {
        show: false,
        color: "#d6d6d6",
      },
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: function (val) {
          return Math.round(val); // Ensure whole numbers
        },
      },
      title: {
        text: "Traffic (KBPS)",
      },
    },
    stroke: {
      width: 1,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      showForSingleSeries: true,
      labels: {
        colors: "#9aa0ac",
        fontSize: "12px",
      }, // Display legend for each series
    },
    colors: ["#fc7594", "#00aaff", "#ffc107", "#28a745"], // Colors for different series
    zoom: {
      enabled: true,
    },
    toolbar: {
      show: false,
    },
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>{localizationStrings?.trafficBandwidth}</h3>
            <div className="card-title-dropdown">
              {/* <div className="btn-group">
                <span
                  className="dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    {localizationStrings?.all}{" "}
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <a className="dropdown-item" href="#">
                        2.4 GHz
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        5 GHz
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        6 GHz
                      </a>
                    </li>
                  </ul>
                </span>
              </div> */}
              <div className="btn-group">
                <span
                  className="dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    {trafficDuration === "24h"
                      ? localizationStrings?.last24Hours
                      : trafficDuration}
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => handleTrafficDurationChange("8h")}
                      >
                        {localizationStrings?.last8Hours}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => handleTrafficDurationChange("24h")}
                      >
                        {localizationStrings?.last24Hours}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => handleTrafficDurationChange("7d")}
                      >
                        {localizationStrings?.last7Days}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => handleTrafficDurationChange("30d")}
                      >
                        {localizationStrings?.last30Days}
                      </a>
                    </li>
                  </ul>
                </span>
              </div>
              {/* <input className="list-search" type="text" /> */}
              <button
                className="icon-btn"
                title="Refresh"
                onClick={() => getTrafficBandwidthData(trafficDuration,networkId)}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>
              </button>
              {/* <button className="icon-btn" title="Filter">
                <i className="fa fa-filter" aria-hidden="true"></i>
              </button> */}
            </div>
          </div>
          <div className="inc-card-body">
            <div className="row">
              <div className="col-lg-8">
                {loading ? (
                  <Loader />
                ) : (
                  <div>
                    {trafficSeries.length === 0 ? (
                      <div className="no-data-box">
                        <div className="no-data-text">
                          {localizationStrings?.noData}
                        </div>
                      </div>
                    ) : (
                      <Chart
                        options={TrafficOptions}
                        series={trafficSeries}
                        type="line"
                        height={170}
                      />
                    )}
                  </div>
                )}
              </div>
              <div className="col-lg-4">
                <div className="round-border">
                  <div className="inc-card-table">
                    <table className="m-head">
                      <thead>
                        <tr>
                          <th>{localizationStrings?.devices}</th>
                          <th>{localizationStrings?.time}</th>
                          <th>{localizationStrings?.traffic}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trafficSeries &&
                          trafficSeries.length > 0 &&
                          trafficSeries.flatMap((seriesItem, seriesIndex) =>
                            seriesItem.data.map((dataItem, dataIndex) => (
                              <tr key={`${seriesIndex}-${dataIndex}`}>
                                <td>{seriesItem.name}</td> {/* Device name */}
                                <td>
                                  {new Date(dataItem.x).toLocaleString()}
                                </td>{" "}
                                {/* Timestamp */}
                                <td>{dataItem.y}</td> {/* Traffic data */}
                              </tr>
                            ))
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrafficBandwithExpandation;
